'use strict';

var globalisation = require('../../utilities/globalisation'),
    $ = require('jquery');

(function( $, globalisation ) {

  var rangeVariables = ['{0}', '{1}'];

  $.extend($.validator.messages, {
    required:   globalisation.pluraliseAndTranslate('formValidation', 'required'),
    remote:     globalisation.pluraliseAndTranslate('formValidation', 'remote'),
    email:      globalisation.pluraliseAndTranslate('formValidation', 'email'),
    url:        globalisation.pluraliseAndTranslate('formValidation', 'url'),
    date:       globalisation.pluraliseAndTranslate('formValidation', 'date'),
    dateISO:    globalisation.pluraliseAndTranslate('formValidation', 'dateISO'),
    number:     globalisation.pluraliseAndTranslate('formValidation', 'number'),
    digits:     globalisation.pluraliseAndTranslate('formValidation', 'digits'),
    creditcard: globalisation.pluraliseAndTranslate('formValidation', 'creditCard'),
    equalTo:    globalisation.pluraliseAndTranslate('formValidation', 'equalTo'),
    accept:     globalisation.pluraliseAndTranslate('formValidation', 'accept'),

    maxlength:   globalisation.pluraliseAndTranslate('formValidation', 'maxLength', '{0}'),
    minlength:   globalisation.pluraliseAndTranslate('formValidation', 'minLength', '{0}'),
    rangelength: globalisation.pluraliseAndTranslate('formValidation', 'rangeLength', rangeVariables),
    range:       globalisation.pluraliseAndTranslate('formValidation', 'range', rangeVariables),
    max:         globalisation.pluraliseAndTranslate('formValidation', 'max', '{0}'),
    min:         globalisation.pluraliseAndTranslate('formValidation', 'min', '{0}'),
    noDuplicate: globalisation.pluraliseAndTranslate('formValidation', 'noDuplicate', '{0}'),
    customValidtionError: globalisation.pluraliseAndTranslate('formValidation', 'customValidationError', '{0}')
  });

}( $, globalisation ));



// WEBPACK FOOTER //
// ./assets/js/third-party/jquery.validate.translations.js